import React, { useEffect, useState } from "react";
import "./Designation.css";
import { BsPencil } from "react-icons/bs";
import { DeleteOutlined, PlusOutlined, StopOutlined } from "@ant-design/icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  AddDesignation,
  BASE_URL,
  DeleteDesignation,
  FetchDesignation,
  UpdateDesignation,
} from "../../utils/constant";
import DesignationForm from "../Designation/DesignationForm";
import { setDesig } from "../../store/slices/designationSlice";
import { useDispatch } from "react-redux";
import ModalConfirm from "../../common/modalConfirm";
function Designation() {
  const dispatch = useDispatch();

  const [designationData, setDesignationData] = useState([]);
  const [designationDisabledData, setDesignationDisabledData] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [modalDeleteDesigVisible, setModalDeleteDesigVisible] = useState(false);
  const [deleteDesigData, setDeleteDesigData] = useState(null);
  const [modalDisableDesigVisible, setModalDisableDesigVisible] = useState(false);
  const [disableDesigData, setDisableDesigData] = useState(null);

  const deleteDesig = (params) => {
    setModalDeleteDesigVisible(true);
    setDeleteDesigData(params);
  };
  const handleOk = (params) => {
    handleDelete(params);
    setModalDeleteDesigVisible(false);
  };
  const handleCancel = () => {
    setModalDeleteDesigVisible(false);
  };
  const disableDesig = (params) => {
    setModalDisableDesigVisible(true);
    setDisableDesigData(params);
  };
  const handleDisableOk = (params) => {
    updateDesignation(params);
    setModalDisableDesigVisible(false);
  };
  const handleDisableCancel = () => {
    setModalDisableDesigVisible(false);
  };
  const [activeDesignationData, setActiveDesignationData] = useState(null);
  const [modalActiveDesignationVisible, setModalActiveDesignationVisible] =
    useState(false);

  const activeBtnDesignation = (params) => {
    setModalActiveDesignationVisible(true);
    setActiveDesignationData(params);
  };
  const handleActiveOk = (params) => {
    const updatedState = { ...params };
    delete updatedState.boOwnerId;
    delete updatedState.isActive;
    delete updatedState.createdAt;
    delete updatedState.createdBy;
    delete updatedState.updateBy;
    delete updatedState.updatedAt;
    updatedState.isActive = true;
    updateDesignation(updatedState);
    setModalActiveDesignationVisible(false);
  };
  const handleActiveCancel = () => {
    setModalActiveDesignationVisible(false);
  };
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const gridOptions = {
    getRowClass: (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return "RowColor";
      }
    },
  };

  const showForm = (item) => {
    setFormVisible(true);
  };
  const hideForm = () => {
    setFormVisible(false);
    setEditItem(null);
  };
  const updateDesignation = (data) => {
    const token = localStorage.getItem("authToken");
    console.log('data',data)
      const { designationId, ...newData } = data;
    
    console.log('newData',newData)

    const fetchData = async () => {
      const response = await fetch(
        `${BASE_URL}/${UpdateDesignation}/${typeof data === 'object' ? data?.designationId : data}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(typeof data === 'object' ? newData : {isActive : false}),
        }
      );

      if (response.ok) {
        const data = await response.json();
        getDesignationList();
      } else {
        const data = await response.json();
        console.log("Designationerr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    fetchData();
  };
  const addDesignation = (data) => {
    const token = localStorage.getItem("authToken");
    const FinalAdddesignation = {
      designations: [data],
    };
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${AddDesignation}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(FinalAdddesignation),
      });

      if (response.ok) {
        const data = await response.json();
        getDesignationList();
      } else {
        const data = await response.json();
        console.log("designationerr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    fetchData();
  };
  const handleAddOrUpdate = (data) => {
    if (data?.designationId) {
      updateDesignation(data);
    } else {
      addDesignation(data);
    }
    setEditItem(null);
    hideForm();
  };
  const handleDelete = async (designationId) => {
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(
        `${BASE_URL}/${DeleteDesignation}/${designationId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({isDeleted:true}),
        }
      );

      if (response.ok) {
        const data = await response.json();
        getDesignationList();
      } else {
        const data = await response.json();
        console.log("departmenterr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    await fetchData();
  };
  const handleEdit = (designation) => {
    setEditItem(null);
    setEditItem(designation);
    showForm();
  };
  useEffect(() => {
    getDesignationList();
  }, []);
  const getDesignationList = async () => {
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${FetchDesignation}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({isDeleted:false}),
      });

      if (response.ok) {
        const data = await response.json();
        const activeDesignation = data.data.filter((item) => item.isActive);
        const disabledDesignation = data.data.filter(
          (item) => item.isActive == false
        );
        setDesignationData(activeDesignation);
        setDesignationDisabledData(disabledDesignation);
        const newArray = activeDesignation.map((item) => ({
          value: item.designationName,
          key: item.designationId,
        }));
        sessionStorage.setItem("designation", JSON.stringify(newArray));
        dispatch(setDesig(newArray));
      } else {
        const data = await response.json();
        console.log("designationerr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    await fetchData();
  };
  const columns = [
    {
      headerName: "Designation Name",
      field: "designation",
    },
    {
      headerName: "Name (short)",
      field: "name",
    },
    {
      headerName: "Description",
      field: "description",
      flex: 1,
    },

    {
      headerName: "Action",
      field: "action",
      cellRenderer: (params) => {
        return (
          <>
            <div className="flex">
              <span className="shi-pen">
                <BsPencil onClick={() => handleEdit(params?.data?.item)} />
              </span>
              <span className="shi-not ml-2">
                <StopOutlined
                  onClick={() => disableDesig(params?.data?.item?.designationId)}
                />
              </span>
              <span className="shi-not ml-2">
                <DeleteOutlined
                  onClick={() => deleteDesig(params?.data?.item?.designationId)}
                />
              </span>
            </div>
          </>
        );
      },
    },
  ];
  const columnsDisabeld = [
    {
      headerName: "Designation Name",
      field: "designation",
    },
    {
      headerName: "Name (short)",
      field: "name",
    },
    {
      headerName: "Description",
      field: "description",
      flex: 1,
    },
    // {
    //   headerName: 'Earned Leave Enabled',
    //   field: 'earned',
    // },
    // {
    //   headerName: 'OT Enabled',
    //   field: 'ot',
    // },
    // {
    //   headerName: 'Active User',
    //   field: 'active',
    // },
    {
      headerName: "Action",
      field: "action",
      cellRenderer: (params) => {
        return (
          <>
            <div className="flex">
              {/* <span className='shi-pen'>
                              <BsPencil onClick={() => handleEdit(params?.data?.item)}/>
                            </span> */}
              <span className="shi-pen ml-2">
                <PlusOutlined
                  onClick={() => activeBtnDesignation(params?.data?.item)}
                />
              </span>
              <span className="shi-not ml-2">
                <DeleteOutlined
                  onClick={() => deleteDesig(params?.data?.item?.designationId)}
                />
              </span>

            </div>
          </>
        );
      },
    },
  ];
  const data = designationData.map((item, index) => ({
    key: index,
    item: item,
    designation: capitalizeFirstLetter(item.designationName),
    name: capitalizeFirstLetter(item.designationShortName),
    description: capitalizeFirstLetter(item.designationDescription),
    // earned: 's',
    // ot: 's',
    // active:  'No',

    actions: (
      <div
        className="flex"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <BsPencil
          style={{
            border: "1px solid #D7E7F8",
            padding: "3px",
            backgroundColor: "#D7E7F8",
            borderRadius: "50%",
            fontSize: "17px",
          }}
        />
        <StopOutlined
          style={{
            border: "1px solid #D7E7F8",
            padding: "3px",
            backgroundColor: "#F5E7E9",
            borderRadius: "50%",
            fontSize: "10px",
            color: "#DC3545",
            marginLeft: "5px",
          }}
        />
      </div>
    ),
  }));
  const disabledData = designationDisabledData.map((item, index) => ({
    key: index,
    item: item,
    designation: capitalizeFirstLetter(item.designationName),
    name: capitalizeFirstLetter(item.designationShortName),
    description: capitalizeFirstLetter(item.designationDescription),

    actions: (
      <div
        className="flex"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <BsPencil
          style={{
            border: "1px solid #D7E7F8",
            padding: "3px",
            backgroundColor: "#D7E7F8",
            borderRadius: "50%",
            fontSize: "17px",
          }}
        />
      </div>
    ),
  }));

  return (
    <div>
      <ToastContainer position="top-right" autoClose={5000} />
      <div className="grid grid-flow-col grid-cols-12">
        <div className="col-span-8">
          <div className="flex justify-between mt-3 items-center">
            <p className="text-[17px] text-[#4B8AEB] font-sbold my-0 relative top-2">
              Active Designation
            </p>
            <button
              onClick={() => showForm(null)}
              className="h-[35px] border !border-[#00305F] !px-5 inline-flex items-center rounded-full font-sbold hover:bg-[#00305F] hover:text-white cursor-pointer transition-all"
            >
              +Add New Designation
            </button>
          </div>

          <div
            className="ag-theme-alpine text-base border-none bordered font-proxima"
            style={{ height: "auto", marginTop: "10px" }}
          >
            <AgGridReact
              gridOptions={gridOptions}
              columnDefs={columns}
              rowData={data}
              domLayout="autoHeight"
              pagination={true}
              paginationPageSize={20}
              getRowHeight={() => 60}
              paginationPageSizeSelector={false}
            />
          </div>
        </div>
      </div>
      <div className="grid grid-flow-col grid-cols-12">
        <div className="col-span-8">
          <p className="text-[17px] text-[#4B8AEB] font-sbold mt-0 mb-3 relative top-2">
            Disabled Designation
          </p>
          <div
            className="ag-theme-alpine text-base border-none font-proxima"
            style={{ height: "auto", marginTop: "10px" }}
          >
            <AgGridReact
              gridOptions={gridOptions}
              columnDefs={columnsDisabeld}
              rowData={disabledData}
              domLayout="autoHeight"
              pagination={true}
              paginationPageSize={20}
              getRowHeight={() => 60}
              paginationPageSizeSelector={false}
            />
          </div>
        </div>
      </div>

      <DesignationForm
        visible={formVisible}
        onCancel={hideForm}
        onAddOrUpdate={handleAddOrUpdate}
        initialValues={editItem}
        isEdit={editItem !== null}
      />
      <ModalConfirm
        visible={modalDeleteDesigVisible}
        onOk={() => handleOk(deleteDesigData)}
        onCancel={handleCancel}
        title="Delete"
        content="Are you sure you want to delete?"
      />
      <ModalConfirm
        visible={modalDisableDesigVisible}
        onOk={() => handleDisableOk(disableDesigData)}
        onCancel={handleDisableCancel}
        title="Disable"
        content="Are you sure you want to disable?"
      />
      <ModalConfirm
        visible={modalActiveDesignationVisible}
        onOk={() => handleActiveOk(activeDesignationData)}
        onCancel={handleActiveCancel}
        title="Enable"
        content="Are you sure you want to enable?"
      />
    </div>
  );
}

export default Designation;
